import { createContext, useContext } from "react";
import type { EventApiResponse } from "@/lib/humhub-api/types";

interface EventLinkPreviewContextValue {
  onEventClick?: (eventData: EventApiResponse) => void;
  currentStudyGroupId?: string;
  showOriginalContent?: boolean;
}

const EventLinkPreviewContext = createContext<EventLinkPreviewContextValue>({});

interface EventLinkPreviewProviderProps {
  onEventClick?: (eventData: EventApiResponse) => void;
  currentStudyGroupId?: string;
  showOriginalContent?: boolean;
  children: React.ReactNode;
}

export const EventLinkPreviewProvider: React.FC<
  EventLinkPreviewProviderProps
> = ({ onEventClick, currentStudyGroupId, showOriginalContent, children }) => {
  const parentContext = useContext(EventLinkPreviewContext);

  return (
    <EventLinkPreviewContext.Provider
      value={{
        onEventClick: onEventClick ?? parentContext.onEventClick,
        currentStudyGroupId:
          currentStudyGroupId ?? parentContext.currentStudyGroupId,
        showOriginalContent:
          showOriginalContent ?? parentContext.showOriginalContent,
      }}
    >
      {children}
    </EventLinkPreviewContext.Provider>
  );
};

export const useEventLinkPreviewContext = (): EventLinkPreviewContextValue => {
  return useContext(EventLinkPreviewContext);
};
